<template>
  <div class="operation_overview">
    <page-box :title="'园区经营总览'">
      <div class="content">
        <div class="switch_box">
          <div
            :class="['item', selIndex == index ? 'active' : '']"
            v-for="(item, index) in switchData"
            :key="index"
            @click="selEcharts(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="overview">
          <div class="pic"></div>
          <div class="text_content">
            <div class="name">经营收入(万)</div>
            <div class="number">
              {{ selIndex === 0 ? overViewData.all / 10 : overViewData.all }}
            </div>
          </div>
        </div>
        <div class="echarts_content">
          <my-echarts :options="overViewEcharts"></my-echarts>
        </div>
      </div>
    </page-box>
  </div>
</template>

<script setup>
import PageBox from '@/components/pageBox/PageBox';
import { ref, reactive, onMounted } from 'vue';
import MyEcharts from '@/baseCpm/MyEcharts/MyEcharts.vue';
import * as echarts from 'echarts';
const switchData = reactive([
  {
    name: '月度',
    id: 0,
  },
  {
    name: '年度',
    id: 1,
  },
]);
let selIndex = ref(0);
const selEcharts = (index) => {
  if (selIndex.value !== index) {
    selIndex.value = index;
    overViewData.value.arr = selIndex.value == 0 ? monthData : yearData;
    getEcharts();
  }
};
let monthData = [
  {
    name: '出租收入',
    value: 600,
  },
  {
    name: '增值服务收入',
    value: 280,
  },
  {
    name: '销售收入',
    value: 450,
  },
  {
    name: '物业管理收入',
    value: 720,
  },
  {
    name: '广告收入',
    value: 400,
  },
  {
    name: '技术服务',
    value: 500,
  },
  {
    name: '其他收入',
    value: 300,
  },
];
let yearData = [
  {
    name: '出租收入',
    value: 600,
  },
  {
    name: '增值服务收入',
    value: 280,
  },
  {
    name: '销售收入',
    value: 450,
  },
  {
    name: '物业管理收入',
    value: 720,
  },
  {
    name: '广告收入',
    value: 400,
  },
  {
    name: '技术服务',
    value: 500,
  },
  {
    name: '其他收入',
    value: 150,
  },
];
let overViewData = ref({
  all: 100,
  color: [
    'rgba(249, 205, 92, 1)',
    'rgba(223, 52, 187, 1)',
    'rgba(253, 126, 73,1)',
    'rgba(198, 255, 82, 1)',
    // rgba(19, 139, 247, 1)
    'rgba(19, 139, 247, 1)',
    'rgba(142, 54, 217, 1)',
    'rgba(65, 214, 11, 1)',
  ],
  arr: selIndex.value == 0 ? monthData : yearData,
});
const color1 = [
  {
    c1: 'rgba(249, 205, 92, 1)',
    c2: 'rgba(249, 205, 92, 0.3)',
  },
  {
    c1: 'rgba(223, 52, 187, 1)',
    c2: 'rgba(223, 52, 187, 0.3)',
  },
  {
    c1: 'rgba(253, 126, 73,1)',
    c2: 'rgba(253, 126, 73,0.3)',
  },
  {
    c1: 'rgba(198, 255, 82, 1)',
    c2: 'rgba(198, 255, 82, 0.3)',
  },
  {
    c1: 'rgba(19, 139, 247, 1)',
    c2: 'rgba(19, 139, 247, 0.3)',
  },
  {
    c1: ' rgba(142, 54, 217, 1)',
    c2: ' rgba(142, 54, 217, 0.3)',
  },
  {
    c1: 'rgba(65, 214, 11, 1)',
    c2: 'rgba(65, 214, 11, 0.3)',
  },
];

const color2 = [
  'rgba(249, 205, 92, 0.3)',
  'rgba(223, 52, 187, 0.3)',
  'rgba(253, 126, 73,0.3)',
  'rgba(198, 255, 82, 0.3)',
  'rgba(19, 139, 247, 0.3)',
  ' rgba(142, 54, 217, 0.3)',
  'rgba(65, 214, 11, 0.3)',
];

let overViewEcharts = ref(null);
const getEcharts = () => {
  let all = 0;
  overViewData.value.arr.forEach((item) => {
    all += item.value;
  });
  overViewData.value.all = all;
  overViewEcharts.value = {
    color: overViewData.value.color,
    legend: {
      top: '10',
      left: '130',
      itemWidth: 8,
      itemHeight: 8,
      icon: 'rect',
      itemGap: 12,
      textStyle: {
        rich: {
          a: {
            fontFamily: 'MiSans',
            fontSize: 11.81,
            lineHeight: 12,
            padding: [0, 0, 0, 4],
            color: 'rgba(239, 233, 255, 1)',
          },
        },
      },
      formatter: function (params) {
        let data = overViewData.value.arr;
        let fil = '';
        let value = 0;
        let all = 0;
        for (let i = 0; i < data.length; i++) {
          if (data[i].name == params) {
            fil += '{a|' + params + '}';
          }
        }

        return fil;
      },
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: ['70%', '90%'],
        center: ['25%', '55%'],
        avoidLabelOverlap: false,
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
        itemStyle: {
          normal: {
            color: function (params) {
              var colorList = color1;
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上

                  offset: 0,
                  color: colorList[params.dataIndex].c1,
                },
                {
                  offset: 1,
                  color: colorList[params.dataIndex].c2,
                },
              ]);
              /*  return colorList[params.dataIndex]*/
            },
          },
        },
        data: overViewData.value.arr,
      },
      {
        name: 'Access From',
        type: 'pie',
        radius: ['50%', '90%'],
        center: ['25%', '55%'],
        avoidLabelOverlap: false,
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
        itemStyle: {
          normal: {
            color: function (params) {
              var colorList = color2;
              return colorList[params.dataIndex];
              /*  return colorList[params.dataIndex]*/
            },
          },
        },
        data: overViewData.value.arr,
      },
    ],
  };
};

onMounted(() => {
  getEcharts();
});
</script>

<style lang="scss" scoped>
.operation_overview {
  margin-bottom: 5px;
  .content {
    margin-left: 20px;
    width: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .switch_box {
      padding-left: 28px;
      box-sizing: border-box;
      display: flex;
      width: 285.52px;
      height: 23.29px;
      background-size: 100% 100%;
      background-image: url(@/assets/images/Situation/switch_bg.png);
      margin-bottom: 13px;
      .item {
        cursor: pointer;
        width: 77.76px;
        height: 23.29px;
        background-size: 100% 100%;
        background-image: none;
        text-align: center;
        color: #e4efff;
        font-family: MiSans;
        font-size: 12.66px;
        font-style: normal;
        font-weight: 400;
        line-height: 23.29px;
        letter-spacing: -0.288px;
        &.active {
          font-family: 'MiSansS';
          background-image: url(@/assets/images/Situation/active_bg.png);
        }
      }
    }
    .overview {
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      .pic {
        width: 77.62px;
        height: 77.62px;
        background-size: 100% 100%;
        background-image: url(@/assets/images/Situation/icon.png);
      }
      .text_content {
        position: relative;
        margin-left: -5px;
        width: 154.91px;
        height: 59.74px;
        background-size: 100% 100%;
        background-image: url(@/assets/images/Situation/text_background.png);
        margin-bottom: 9px;
        .name {
          position: absolute;
          left: 29px;
          top: 9px;
          color: rgba(24, 177, 254, 0.7);
          font-family: 'MiSansM';
          font-size: 13.5px;
          font-style: normal;
          font-weight: 500;
          line-height: 19.2px; /* 120% */
        }
        .number {
          position: absolute;
          left: 40px;
          top: 28px;
          color: #ffec90;
          text-align: center;
          font-family: 'MiSansS';
          font-size: 22.25px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }
      }
    }
    .echarts_content {
      width: 310px;
      height: 105.6px;
    }
  }
}
</style>
